module.exports = __webpack_public_path__ + "img/ksj009.prt.491a7008.jpg";